<template>
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
  >
    <path d="M10 0.5C15.5228 0.5 20 4.97715 20 10.5C20 16.0228 15.5228 20.5 10 20.5C4.47715 20.5 0 16.0228 0 10.5C0 4.97715 4.47715 0.5 10 0.5ZM10 2C5.30558 2 1.5 5.80558 1.5 10.5C1.5 15.1944 5.30558 19 10 19C14.6944 19 18.5 15.1944 18.5 10.5C18.5 5.80558 14.6944 2 10 2ZM10 5.5C10.4142 5.5 10.75 5.83579 10.75 6.25V9.75H14.25C14.6642 9.75 15 10.0858 15 10.5C15 10.9142 14.6642 11.25 14.25 11.25H10.75V14.75C10.75 15.1642 10.4142 15.5 10 15.5C9.58579 15.5 9.25 15.1642 9.25 14.75V11.25H5.75C5.33579 11.25 5 10.9142 5 10.5C5 10.0858 5.33579 9.75 5.75 9.75H9.25V6.25C9.25 5.83579 9.58579 5.5 10 5.5Z" />
  </svg>
</template>
